import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from './icons/CheckIcon';
import { ArrowIcon } from './icons/ArrowIcon';
export function Pricing() {
  return <section id="precio" className="py-12 px-4 bg-[#FDFBF7]" data-id="element-207">
      <div className="max-w-4xl mx-auto" data-id="element-208">
        <div className="text-center mb-8 space-y-2" data-id="element-209">
          <h2 className="text-2xl md:text-3xl font-semibold text-[#3D3028]" data-id="element-210">
            INVERSIÓN ESPECIAL POR TIEMPO LIMITADO
          </h2>
        </div>

        <div className="bg-white rounded-2xl overflow-hidden border border-[#D4C4B0]/20 max-w-lg mx-auto" data-id="element-211">
          <div className="bg-[#3D3028] p-6 text-center" data-id="element-212">
            <h3 className="text-[#FAF8F4] text-xl font-semibold mb-1" data-id="element-213">
              MASTER HYDRA GLOSS LIPS™ 2.0
            </h3>
            <p className="text-[#E5A5A0] font-medium text-xs" data-id="element-214">
              Oferta exclusiva
            </p>
          </div>

          <div className="p-8" data-id="element-215">
            <div className="flex flex-col items-center mb-8" data-id="element-216">
              <span className="text-[#3D3028]/40 text-base line-through mb-2" data-id="element-217">
                Precio normal: $97 USD
              </span>
              <div className="text-5xl font-semibold text-[#3D3028] mb-2" data-id="element-218">
                $27 <span className="text-lg text-[#3D3028]/50" data-id="element-219">USD</span>
              </div>
              <span className="bg-[#E5A5A0]/10 text-[#E5A5A0] px-4 py-1.5 rounded-full text-xs font-semibold uppercase tracking-wide" data-id="element-220">
                Hoy solo
              </span>
            </div>

            <ul className="space-y-3 mb-8" data-id="element-221">
              {['Videos completos paso a paso', 'Material profesional descargable', '7 bonos exclusivos incluidos', 'Pago único - Sin mensualidades', 'Compra 100% segura', 'Acceso inmediato'].map((item, index) => <li key={index} className="flex items-center gap-2" data-id="element-222">
                  <CheckIcon className="w-4 h-4 text-[#E5A5A0] flex-shrink-0" data-id="element-223" />
                  <span className="text-[#3D3028]/80 text-sm" data-id="element-224">{item}</span>
                </li>)}
            </ul>

            <motion.a href="https://www.hydraglosslips.com/cart/47717496684792:1" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="block w-full bg-[#E5A5A0] hover:bg-[#d99590] text-white font-semibold py-4 rounded-full text-base transition-colors duration-300 mb-5 text-center" data-id="element-225">
              Accedé ahora al Master
            </motion.a>

            <div className="space-y-2 text-xs text-[#3D3028]/60" data-id="element-226">
              <div className="flex items-start gap-2" data-id="element-227">
                <ArrowIcon className="w-3.5 h-3.5 mt-0.5 text-[#E5A5A0] flex-shrink-0" data-id="element-228" />
                <p data-id="element-229">Invertís menos de lo que cuesta una sola práctica</p>
              </div>
              <div className="flex items-start gap-2" data-id="element-230">
                <ArrowIcon className="w-3.5 h-3.5 mt-0.5 text-[#E5A5A0] flex-shrink-0" data-id="element-231" />
                <p data-id="element-232">Y obtenés una habilidad que podés monetizar durante años</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}